import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AutorizaRotaService } from 'src/app/service/shared/autoriza-rota.service';
import { StorageService } from 'src/app/service/shared/storage.service';

export const authGuard: CanActivateFn = (route, state): boolean => {
  const storage = inject(StorageService);
  const router = inject(Router);
  const autorizaRota = inject(AutorizaRotaService);

  if (storage.isloggedIn()) {
    var rotaRaiz = route.routeConfig?.path?.toString();
    var path = route.children[0]?.routeConfig?.path?.toString();

    // const id_rota = route.data?.['id_rota'];
    // if (autorizaRota.temAcessoRota(id_rota)) {
    return true;
    // } else {
    //   router.navigate(['/home'])
    //   return false;
    // }
  }
  else {
    router.navigate(['/login']);
    return false;
  }
};
